var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Icon } from '@gerdau/hefesto/Icon';
import { InputWrapper } from '@gerdau/hefesto/InputWrapper';
import './DateField.styles.scss';
import DateFieldRange from './DateFieldRange/DateFieldRange';
import DateFieldSingle from './DateFieldSingle/DateFieldSingle';
var DateField = function (props) {
    var disabled = props.disabled, helperText = props.helperText, helperTextTooltipPlacement = props.helperTextTooltipPlacement, hideLabel = props.hideLabel, label = props.label, name = props.name, readOnly = props.readOnly, _a = props.selectsRange, selectsRange = _a === void 0 ? false : _a, supportMessage = props.supportMessage, variant = props.variant;
    var containerRef = useRef(null);
    var inputWrapperRef = useRef(null);
    var _b = useState(false), showCalendar = _b[0], setShowCalendar = _b[1];
    var onOpenCalendar = function () {
        if (disabled || readOnly) {
            return;
        }
        setShowCalendar(true);
    };
    var onCloseCalendar = function () {
        setShowCalendar(false);
    };
    var getContainerClassName = function () {
        var classList = ['hefesto-datefield'];
        classList.push("hefesto-datefield--".concat(variant));
        if (selectsRange) {
            classList.push("hefesto-datefield--range");
        }
        if (disabled) {
            classList.push("hefesto-datefield--disabled");
        }
        if (readOnly) {
            classList.push("hefesto-datefield--readOnly");
        }
        return classList.join(' ');
    };
    var containerClassName = getContainerClassName();
    var checkOutsideClick = function (event) {
        var _a;
        if (showCalendar &&
            !!event &&
            !!containerRef.current &&
            !containerRef.current.contains(event.target) &&
            !((_a = event.target.parentElement) === null || _a === void 0 ? void 0 : _a.classList.value.includes('react-calendar'))) {
            onCloseCalendar();
        }
    };
    useEffect(function () {
        window.addEventListener('click', checkOutsideClick);
        return function () { return window.removeEventListener('click', checkOutsideClick); };
    });
    return (_jsx(InputWrapper, __assign({ disabled: disabled, helperText: helperText, helperTextTooltipPlacement: helperTextTooltipPlacement, hideLabel: hideLabel, label: label, supportMessage: supportMessage, variant: variant, name: name }, { children: _jsx("div", __assign({ className: containerClassName, "data-testid": "hefesto-datefield", ref: containerRef }, { children: _jsxs("div", __assign({ className: "hefesto-datefield__wrapper", ref: inputWrapperRef }, { children: [!selectsRange && (_jsx(DateFieldSingle, __assign({}, props, { showCalendar: showCalendar, setShowCalendar: setShowCalendar, inputWrapperRef: inputWrapperRef }))), selectsRange && (_jsx(DateFieldRange, __assign({}, props, { showCalendar: showCalendar, setShowCalendar: setShowCalendar, inputWrapperRef: inputWrapperRef }))), _jsx("div", __assign({ className: "hefesto-datefield__right-icon-wrapper" }, { children: _jsx("i", __assign({ onClick: showCalendar ? onCloseCalendar : onOpenCalendar }, { children: _jsx(Icon, { option: "Calendar", variant: readOnly ? 'tertiary' : variant }) })) }))] })) })) })));
};
export default DateField;
